import axios from 'axios'
import { FormatTransactionData } from './format'

// Create axios instance with conditional baseURL
const api = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? 'http://localhost:3540' : 'https://www.usepinto.com',
  maxRedirects: 5, // Allow up to 5 redirects
  validateStatus: function (status) {
    return status >= 200 && status < 400; // Accept 2xx and 3xx status codes
  }
})

export const GetQbCompanyDetails = async (id) => {
  try {
    let res = await api({
      url: '/api/qb-company-details?id='+id,
      method: 'GET',
    })
    return res.data
  } catch(e) {
    console.error('GetQbCompanyDetails error:', e);
    if (e.response?.data?.error) {
      throw new Error(`Get QB Company Details: Error ${e.response.data.error}`);
    }
    throw new Error(`Get QB Company Details: ${e.message || 'Unknown error occurred'}`);
  }
}

export const GetMetabaseEmbed = async (dashboardId, reportId, reportDate, userId) => {
  try {
    let res = await api({
      url: `/api/embed-metabase?dashboardId=${encodeURIComponent(dashboardId)}&reportId=${encodeURIComponent(reportId)}&userId=${encodeURIComponent(userId)}&reportDate=${encodeURIComponent(reportDate)}`,
      method: 'GET',
    })
    return res.data
  } catch(e) {
    console.log(e.message)
  }
}

export const GetImgEmbed = async (imgUrl, userId) => {
  try {
    let res = await api({
      url: `/api/embed-img?imgUrl=${encodeURIComponent(imgUrl)}&userId=${encodeURIComponent(userId)}`,
      method: 'GET',
    })
    return res.data
  } catch(e) {
    console.log(e.message)
  }
}

export const GetChartOfAccounts = async (companyId) => {
  try {
    let res = await api.get('/api/qb-chart-of-accounts', {
      params: {
        companyId: companyId,
        asJson: true,
      }
    });
  
    // console.log('Company Chart of Accounts Unformatted: ', res.data)
    return res.data; 
    //return FormatTransactionData(res.data);  
  } catch(e) {
    console.log(e.message);
  }
}

export const GetCompanyTransactions = async (id, startDate, endDate, groupBy) => {
  try {
    let res = await api.get('/api/qb-transactions', {
      params: {
        id: id,
        startDate: startDate,
        endDate: endDate,
        groupBy: groupBy
      }
    });
  
    console.log('Company Transactions Unformatted: ', res.data)
    return FormatTransactionData(res.data);  
  } catch(e) {
    console.log('Get Company Transactions API util error: ', e);
  }
}

export const GetPdfEmbed = async (pdfUrl, userId) => {
  try {
    let res = await api({
      url: `/api/embed-pdf?pdfUrl=${encodeURIComponent(pdfUrl)}&userId=${encodeURIComponent(userId)}`,
      method: 'GET',
    })
    return res.data
  } catch(e) {
    console.log(e.message)
  }
}

export const GetPnlData = async (id, settings) => {
  try {
    const { pnl_start_date, pnl_end_date, account_method, summarize_column_by } = settings;
    let res = await api({
      url: `/api/qb-profit-and-loss?id=${encodeURIComponent(id)}&pnl_start_date=${encodeURIComponent(pnl_start_date)}&pnl_end_date=${encodeURIComponent(pnl_end_date)}&accounting_method=${encodeURIComponent(account_method)}&summarize_column_by=${encodeURIComponent(summarize_column_by)}`,
      method: 'GET',
    })
    return res.data
  } catch(e) {
    console.error('GetPnlData error:', e);
    if (e.response?.data?.error) {
      throw new Error(`Get QB Profit & Loss: Error ${e.response.data.error}`);
    }
    throw new Error(`Get QB Profit & Loss: ${e.message || 'Unknown error occurred'}`);
  }
}

export const GetReportData = async (reportId, companyId, userId) => {
  try {
    let res = await api({
      url: `/api/report-data?reportId=${encodeURIComponent(reportId)}&companyId=${encodeURIComponent(companyId)}&userId=${encodeURIComponent(userId)}`,
      method: 'GET',
    })
    return res.data
  } catch(e) {
    console.error('GetReportData error:', e);
    if (e.response?.data?.error) {
      throw new Error(`Get Report Data: Error ${e.response.data.error}`);
    }
    if (e.code === 'ERR_BAD_REQUEST') {
      throw new Error('Unable to fetch report data. Please try again later.');
    }
    throw new Error(`Get Report Data: ${e.message || 'Unknown error occurred'}`);
  }
}

export const CreateReport = async (companyId, userId) => {
  try {
    let res = await api({
      headers: {
        'Content-Type': 'application/json'
      },
      data: {
        companyId: companyId,
        userId: userId,
      },
      url: `/api/create-new-report`,
      method: 'POST',
    })
    return res.data
  } catch(e) {
    console.log(e.message)
  }
}

export const UpdateTransaction = async (companyId, transaction, note) => {
  try {
    let res = await api({
      headers: {
        'Content-Type': 'application/json'
      },
      data: {
        companyId,
        transaction,
        note
      },
      url: `/api/qb-update-transaction`,
      method: 'POST',
    })
    return res.data
  } catch(e) {
    console.log(e.message)
  }
}

export const sendToSlack = async (data) => {
  try {
    let res = await fetch('/api/sendToSlack', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data),
      cache: 'default'
    })
    console.log(res)
    return
  } catch (e) {
    console.log(e.message)
    return
  }
}

export const PrintReport = async (reportId, companyId, userId) => {
  try {
    let res = await api({
      url: `/api/report-print?reportId=${reportId}&companyId=${companyId}&userId=${userId}`,
      method: 'GET',
    });
    
    return res.data;
  } catch(e) {
    console.log(e);
    return;
  }
}
